import { Provider } from './provider';
import { WorkshopType } from './workshopTypes';

export type Department = {
  id: string;
  name: string;
};

export type WorkshopKind = 'Matrix' | 'Branch';

export type WorshopActive = 'Active' | 'Disabled';

export type WorkshopTrack = {
  trackCode: string;
  priority: number;
  kindNumber: number;
};

export type Workshop = {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
  pictureUrl: string;
  createdAt?: string | null;
  municipio: {
    id: string;
    name: string;
    department: Department;
  } | null;
  address: string | null; //direccion taller
  workShopType: WorkshopType | null;
  branchOffice: {
    id: string;
    name: string; //sucursal
    zone: {
      id: number;
      name: string; //zona
    };
  };
  mechanics: number | null;
  capacity: number | null;
  provider: Provider | null;

  //propietario
  ownerName: string | null;
  ownerLastName: string | null;
  ownerEmail: string | null;
  ownerCellphone: string | null;

  //comprador
  buyer: string | null;
  buyerLastName: string | null;
  buyerCellphone: string | null;
  email: string | null;

  potential: string;
  tools: boolean;
  active: WorshopActive;
  diagnostics: boolean;
  status: string;
  lastSync: string | null;
  //license: string | null; //carnet | cuentaTA => TA
  clientAccount: string | null; //cliente
  //event: string; //evento???? ***no es
  seller: string | null;
  program: string | null; // program TA
  weeklyCars: number;
  matrix: boolean;
  kind: WorkshopKind | null;
  assistants: number | null;
  track: string | null;
  tracks: WorkshopTrack[] | null;
  kindNumber: number;
  kindAmount: number | null;

  //new fields user
  userCreator: string | null; //usuario creador
  userProfiler: string | null; //usuario perfilador
  userVerifier: string | null; //usuario verificador

  //new fields manager
  managerName: string | null; //nombre gerente
  managerLastName: string | null; //apellido gerente
  managerEmail: string | null; //email gerente
  managerCellphone: string | null; //celular gerente

  isOwnerSeller: boolean; // Indica si el propietario es también el vendedor
  isOwnerManager: boolean; // Indica si el propietario es también el gerente
  isManagerSeller: boolean; // Indica si el gerente es también el vendedor

  dateCreator: string | null;
  dateProfiler: string | null;
  dateVerifier: string | null;

  isFullyActive: boolean;
};

export function getWorkshopStatus(status: string) {
  switch (status) {
    case 'Created':
      return { color: 'white', type: 'Taller', fix: 'inerit', title: 'Creado' };
    case 'Migrated':
      return { color: 'orange', type: 'Taller Migrado', fix: 'white', title: 'Migrado' };
    case 'Profiled':
      return { color: '#b0acab', type: 'Perfilado', fix: 'white', title: 'Perfilado' };
    case 'ProfiledCompleted':
      return {
        color: '#161616',
        type: 'Perfilado Completado',
        fix: 'white',
        title: 'Perfilado Completado',
      };
    case 'TaCreated':
      return { color: 'red', type: 'TA', fix: 'white', title: 'TA Creado' };
    case 'TaProfiled':
      return {
        color: '#fffe01',
        type: 'T.A Perfilado',
        fix: 'inerit',
        title: 'T.A Perfilado',
      };
    case 'TaProfiledCompleted':
      return {
        color: '#51a634',
        type: 'T.A Perfilado Completado',
        fix: 'white',
        title: 'T.A Perfilado Completado',
      };
    case 'Censused':
      return { color: '#5400CB', type: 'Taller Censado', fix: 'white', title: 'Censado' };
    case 'TaProfiledIncompleted':
      return {
        color: '#ea742d',
        type: 'T.A.perfilado_M.incompleto',
        fix: '#333333',
        title: 'T.A.perfilado_M.incompleto',
      };
    case 'TaVerifiedIncompleted':
      return {
        color: '#196b21',
        type: 'T.A_P.Completado_M.incompleto',
        fix: 'white',
        title: 'T.A_P.Completado_M.incompleto',
      };
    case 'ProfiledIncompleted':
      return {
        color: '#abc8ec',
        type: 'Perfilado_M.incompleto',
        fix: '#333333',
        title: 'Perfilado_M.incompleto',
      };
    case 'VerifiedIncompleted':
      return {
        color: '#215c98',
        type: 'P.Completado_M.incompleto',
        fix: 'white',
        title: 'P.Completado_M.incompleto',
      };
  }
}

export type FilterWorkshop = {
  NameContains: string | null;
  Status: string | null;
  ZoneId: number | null;
  OfficeId: string | null;
  DaysBefore: number | null;
  Account: string | null;
  StartDate: string | null;
  EndDate: string | null;
  Active: string | null;
};

export type WorkshopStatus = {
  status: string;
  active: number;
  disabled: number;
  erased: number;
  deprecated: number;
};
